/**
 * `GET /collections/{contract}/offers` `page.last_page` IS NOT A PAGE COUNT —
 * IT IS `current_page - 1`, REGARDLESS OF HOW MANY OFFERS ACTUALLY EXIST.
 *
 * Measured against the live API on `0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d`
 * (3,171 total offers): `page=1` (default limit) returns `last_page: 0`;
 * `page=1&limit=3` also returns `last_page: 0`; `page=2&limit=3` returns
 * `last_page: 1`; `page=1057&limit=3` returns `last_page: 1056`; `page=99999`
 * returns `last_page: 99998` with an empty `items` array. `total` and
 * `per_page`, by contrast, read identically (3171 / the requested limit) across
 * every one of those requests, and the rows themselves page correctly and
 * without repetition — page 1057 at limit=3 returns three offers from 2022,
 * distinct from page 1's 2026 offers.
 *
 * Feeding the raw `last_page` to the shared `Pagination` component would hide
 * pagination entirely on the first request (`lastPage <= 1` there) and disable
 * "Next" from page 1 onward (`currentPage` is always one greater than
 * `lastPage`). `total`/`per_page` are the trustworthy half of this endpoint's
 * page metadata, so the page count is derived from them instead — this is
 * still page-metadata-driven, not a guess from the current page's row count
 * (the thing `Pagination`'s own contract forbids).
 */
export function deriveOffersLastPage(total: number, perPage: number): number {
  if (!Number.isFinite(total) || total <= 0) return 0;
  if (!Number.isFinite(perPage) || perPage <= 0) return 0;
  return Math.ceil(total / perPage);
}
